import React from 'react';
import { Box, Modal, Backdrop } from '@mui/material';
import { Atom } from 'react-loading-indicators';

const OCRLoadingModal = ({ isLoading, showText = true, text = "Please wait while we process your documents...",spinnerText = "Processing OCR" }) => {
  return (
    <Modal
      open={isLoading}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
        sx: {
          backgroundColor: 'rgba(255, 255, 255, 0.1)', // Very subtle white overlay
          backdropFilter: 'blur(8px)', // Glass effect
          WebkitBackdropFilter: 'blur(8px)', // Safari support
        }
      }}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box
        sx={{
          background: 'rgba(255, 255, 255, 0.25)', // Semi-transparent white
          backdropFilter: 'blur(10px)',
          WebkitBackdropFilter: 'blur(10px)',
          border: '1px solid rgba(255, 255, 255, 0.3)',
          borderRadius: '20px',
          padding: '40px 60px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          width: {
            xs: '90%',   
            sm: 'auto'   
  },
          minWidth: '300px',
          minHeight: '200px',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
        }}
      >
        <Atom 
          color={["#32cd32", "#327fcd", "#cd32cd", "#cd8032"]} 
          size="large" 
          // text="Processing OCR" 
          text={spinnerText} 
          textColor= "#d22129"
        />
        {/* <Box
          sx={{
            marginTop: '20px',
            textAlign: 'center',
            color: '#333',
            fontFamily: 'Inter-Medium, sans-serif',
          }}
        > */}
          
          {/* <p style={{ margin: '0', fontSize: '14px', opacity: 0.8 }}>
            Please wait while we process your documents...
          </p> */}

          {showText && (
          <p style={{ margin: '0', fontSize: '14px', opacity: 0.8 }}>
            {text}
          </p>
        )}
        {/* </Box> */}
      </Box>
    </Modal>
  );
};

export default OCRLoadingModal;